import { useState, useEffect, useRef } from 'react';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { useLanguage } from '@/contexts/LanguageContext';

export function TransliterateInput({ value, onChange, multiline = false, ...props }) {
  const { isGujarati, transliterate } = useLanguage();
  const [localVal, setLocalVal] = useState(value || '');
  const isTranslating = useRef(false);

  useEffect(() => {
    if (!isTranslating.current) {
      setLocalVal(value || '');
    }
  }, [value]);

  const handleChange = async (e) => {
    const newVal = e.target.value;
    setLocalVal(newVal);

    if (isGujarati && newVal.endsWith(' ') && !isTranslating.current) {
      const trimmed = newVal.trimEnd();
      const lastSpaceIdx = trimmed.lastIndexOf(' ');
      const lastWord = trimmed.substring(lastSpaceIdx + 1);

      if (lastWord && /^[a-zA-Z]+$/.test(lastWord)) {
        isTranslating.current = true;
        try {
          const result = await transliterate(lastWord);
          const prefix = lastSpaceIdx >= 0 ? trimmed.substring(0, lastSpaceIdx + 1) : '';
          const newText = prefix + result + ' ';
          setLocalVal(newText);
          onChange?.(newText);
        } catch {
          onChange?.(newVal);
        }
        isTranslating.current = false;
        return;
      }
    }
    onChange?.(newVal);
  };

  const Comp = multiline ? Textarea : Input;
  return <Comp value={localVal} onChange={handleChange} {...props} />;
}
